// import React from "react";
import React from "react";
import "./App.css";
import AppRoutes from "./routes/routes";
import { VoyageProvider } from "./context/VoyageContext";
import OfflineIndicator from "./components/OfflineIndicator";
import { DateProvider } from "./context/DateContext";

function App() {
  return (
    <VoyageProvider>
      <DateProvider>
        <OfflineIndicator />
        <AppRoutes />
      </DateProvider>
    </VoyageProvider>
  );
}

export default App;
